const DEBUG = false;
const DEV = false;
const API_SOCKET = 'eyJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJJRUEiLCJlbWFpbCI6ImVkdWFyZG9pdG9lc3RlQGdtYWlsLmNvbSIsInBhc3N3b3JkIjoiJDJiJDEwJEM0M2M1dUl4R3BoVzk1RElod0ZJVWUzT1BFVDFjbTdQNzZMTTVuM2daWFNUNS5EaWFTRHNHIiwiY2hhbm5lbCI6IklFQSIsInVwZGF0ZWRBdCI6IjIwMjAtMTEtMzBUMTE6MTQ6MTIuODMxWiIsImNyZWF0ZWRBdCI6IjIwMjAtMTEtMzBUMTE6MTQ6MTIuODMxWiJ9.M8TW0YDXeSNuns-VTKIK0NtauWBQ2UceDrqgJUtiDQ0';
const OPENAI_API_KEY = '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';
module.exports = {
  DEBUG,
  DEV,
  API_SOCKET,
  OPENAI_API_KEY
};

 
